import React, { KeyboardEventHandler } from 'react';
import { useState, useEffect, useMemo, useCallback } from 'react'

import { MeasurementSystem, Measurement, MeasurementKey, DerivedMeasurement, LineMeasurement } from './measurements/MeasurementSystem';
import { MeasurementProvider, useMeasurements } from './measurements/Context';

import SelvesterScore from './measurements/collections/SelvesterScore';
import MeasurementTestComponent from './components/MeasurementTestComponent';
import ECGEditor from './components/ECGEditor';
import { FirebaseProvider } from './providers/FirebaseProvider';
import { BrowserRouter, Route, RouterProvider, Routes } from 'react-router-dom';
import { ProfileProvider } from './providers/ProfileProvider';
import { ProjectProvider } from './providers/ProjectProvider';
import { Root } from './routes/Root';
import { EditorPage } from './routes/pages/EditorPage';
import ProjectsLayout from './routes/pages/projects/ProjectsLayout';
import { ProjectListPage } from './routes/pages/projects/ProjectListPage';
import { ProjectDetailPage } from './routes/pages/projects/ProjectDetailPage';
import Home from './routes/pages/Home';
import { NewMeasurementSystemTestPage } from './routes/pages/test/NewMeasurementSystemTestPage';
import { FirebaseImageProvider } from './providers/FirebaseImageProvider';

export default function App() {
  return (
    <React.StrictMode>
      <FirebaseProvider>
        <ProfileProvider>
          <ProjectProvider>
            <FirebaseImageProvider>
              <BrowserRouter>
              <Routes>
                  <Route path="/" element={<Root/>}>
                    <Route index element={<Home/>}/>
                    <Route path="measurements-test" element={<NewMeasurementSystemTestPage/>}/>
                    <Route path="editor/:projectId/:task/:imageId" element={<EditorPage />} />
                    <Route path="/projects" element={<ProjectsLayout/>}>
                        <Route index element={<ProjectListPage/>}/>
                        <Route path=":projectId" element={<ProjectDetailPage/>}/>
                    </Route>
                  </Route>
              </Routes>
              </BrowserRouter>
              </FirebaseImageProvider>
          </ProjectProvider>
        </ProfileProvider>
      </FirebaseProvider>
    </React.StrictMode>
  )
}